/**
 * tabConfig — config partagée des onglets de navigation.
 *
 * Utilisé par :
 *  - OutfitTabBar (TabNavigator.js, bottom bar mobile/native)
 *  - WebSidebar (components/WebSidebar.js, sidebar desktop web)
 *
 * v1.12.117 — extrait pour permettre 2 rendus de nav (bottom + sidebar).
 */

import React from 'react';
import Svg, { Path, Circle, Rect, Line } from 'react-native-svg';

// v1.12.71 — Icônes 24px (taille Facebook iOS)
const SZ = 24;

// Composant Icon générique — prend `name`, `active`, `colorOn`, `colorOff`
export function TabIcon({ name, active, colorOn = '#1A1814', colorOff = '#C8C0B4', size = SZ }) {
  const c = active ? colorOn : colorOff;
  const w = active ? 1.8 : 1.2;
  switch (name) {
    case 'home':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path d="M3 9.5L12 3l9 6.5V21H15v-5h-6v5H3V9.5z" stroke={c} strokeWidth={w} strokeLinejoin="round"/>
      </Svg>;
    case 'looks':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path d="M12 2C9.24 2 7 4.24 7 7v2H5l1.5 13h11L19 9h-2V7c0-2.76-2.24-5-5-5z" stroke={c} strokeWidth={w} strokeLinejoin="round"/>
      </Svg>;
    case 'catalog':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Rect x="3" y="3" width="7" height="7" rx="1" stroke={c} strokeWidth={w}/>
        <Rect x="14" y="3" width="7" height="7" rx="1" stroke={c} strokeWidth={w}/>
        <Rect x="3" y="14" width="7" height="7" rx="1" stroke={c} strokeWidth={w}/>
        <Rect x="14" y="14" width="7" height="7" rx="1" stroke={c} strokeWidth={w}/>
      </Svg>;
    case 'wardrobe':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Rect x="4" y="3" width="16" height="18" rx="1" stroke={c} strokeWidth={w} strokeLinejoin="round"/>
        <Line x1="12" y1="3" x2="12" y2="21" stroke={c} strokeWidth={w}/>
        <Line x1="10.5" y1="11" x2="10.5" y2="13" stroke={c} strokeWidth={w * 1.4} strokeLinecap="round"/>
        <Line x1="13.5" y1="11" x2="13.5" y2="13" stroke={c} strokeWidth={w * 1.4} strokeLinecap="round"/>
        <Line x1="6.5" y1="21" x2="6.5" y2="22.5" stroke={c} strokeWidth={w} strokeLinecap="round"/>
        <Line x1="17.5" y1="21" x2="17.5" y2="22.5" stroke={c} strokeWidth={w} strokeLinecap="round"/>
      </Svg>;
    case 'travel':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" stroke={c} strokeWidth={w} strokeLinejoin="round"/>
      </Svg>;
    case 'favorites':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill={active ? c : 'none'}>
        <Path d="M12 21s-7-4.35-9.5-9C1 8 3 4 7 4c2 0 3.5 1 5 2.5C13.5 5 15 4 17 4c4 0 6 4 4.5 8-2.5 4.65-9.5 9-9.5 9z" stroke={c} strokeWidth={w} strokeLinejoin="round"/>
      </Svg>;
    case 'cart':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke={c} strokeWidth={w} strokeLinejoin="round"/>
        <Line x1="3" y1="6" x2="21" y2="6" stroke={c} strokeWidth={w}/>
        <Path d="M16 10a4 4 0 01-8 0" stroke={c} strokeWidth={w}/>
      </Svg>;
    case 'profile':
      return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Circle cx="12" cy="8" r="4" stroke={c} strokeWidth={w}/>
        <Path d="M4 20c0-4 3.58-7 8-7s8 3 8 7" stroke={c} strokeWidth={w} strokeLinecap="round"/>
      </Svg>;
    default: return null;
  }
}

// v1.12.238 — Voyage retiré du menu principal (accès via Profil ou autre point ultérieur)
// v1.12.262 — labelKey i18n + label fallback (FR par défaut)
// Ordre : Accueil → Catalogue → Looks IA → Dressing → Favoris → Profil
export const TABS = [
  { key: 'Home',        label: 'Accueil',   labelKey: 'nav_home',      icon: 'home'      },
  { key: 'Catalogue',   label: 'Catalogue', labelKey: 'nav_catalog',   icon: 'catalog'   },
  { key: 'Suggestions', label: 'Looks IA',  labelKey: 'nav_looks_ia',  icon: 'looks'     },
  { key: 'Garde-robe',  label: 'Dressing',  labelKey: 'nav_wardrobe',  icon: 'wardrobe'  },
  { key: 'Favoris',     label: 'Favoris',   labelKey: 'nav_favorites', icon: 'favorites' },
  { key: 'Profil',      label: 'Profil',    labelKey: 'nav_profile',   icon: 'profile'   },
];
